import { ReactComponent as ChevronDown } from "../../../assets/icons/chevron-down.svg";
import LineText from "../../../Libraries/LineText";
import { analytics, triggerLogEvent } from "../../../config/firebase";

const StockDropDownInput = ({
  label = "",
  params = {},
  placeholder = "",
  className = "",
  disabled = false,
  required,
  id,
}) => {
  const isFocused = params?.inputProps?.["aria-controls"] != null;
  return (
    <>
      <LineText className={`fontSize14 newFontColor ${label ? "mb-2" : ""}`}>
        {label} {required && <span style={{ color: "red" }}>*</span>}
      </LineText>
      <div
        ref={params?.InputProps?.ref}
        className={`dropdown-input-base ${className}`}
      >
        <input
          type='text'
          placeholder={placeholder}
          id={id || params?.inputProps?.id}
          {...params?.inputProps}
          disabled={disabled}
        />
        <ChevronDown
          style={isFocused ? { transform: "rotate(180deg)" } : {}}
          role='button'
          onClick={(e) => {
            if (disabled) return;
            else {
              triggerLogEvent(analytics, "sb_variant_dropdown", { dropdown_id: id });
              params?.inputProps?.onMouseDown();
              params?.inputProps?.onFocus();
            }
          }}
        />
      </div>
    </>
  );
};

export default StockDropDownInput;
